<template>
  <div>
    <base-header class="pb-6 bg-pulse-blue">
      <b-row align-v="center" class="py-4">
        <b-col cols="7" lg="6">
          <h6 class="h2 text-white d-inline-block mb-0">Pulse Dashboard</h6>
        </b-col>
      </b-row>
    </base-header>
    <b-container fluid class="mt--6">
      <b-card no-body v-if="loading">
        <loading-panel></loading-panel>
      </b-card>
      <div v-else>
        <b-card-group deck v-if="goals">
          <b-card no-body>
            <b-card-header>
              <h3 class="mb-0">Annual Goals</h3>
            </b-card-header>
            <b-list-group flush>
              <b-list-group-item class="d-flex justify-content-between align-items-center">
                <h4 class="mb-0">Average Commission:</h4>
                <span class="badge badge-primary badge-pill">{{ commission | currency }}</span>
              </b-list-group-item>
              <b-list-group-item class="d-flex justify-content-between align-items-center">
                <h4 class="mb-0">Closed Volume:</h4>
                <span class="badge badge-primary badge-pill">{{ volume | currency }}</span>
              </b-list-group-item>
              <b-list-group-item class="d-flex justify-content-between align-items-center">
                <h4 class="mb-0">Closed Units:</h4>
                <span class="badge badge-primary badge-pill">{{ units }}</span>
              </b-list-group-item>
              <b-list-group-item class="d-flex justify-content-between align-items-center">
                <h4 class="mb-0">Total Conversations:</h4>
                <span class="badge badge-primary badge-pill">{{ conversations.toFixed() }}</span>
              </b-list-group-item>
              <b-list-group-item class="d-flex justify-content-between align-items-center">
                <h4 class="mb-0">Total Appointments Held:</h4>
                <span class="badge badge-primary badge-pill">{{ appointments.toFixed() }}</span>
              </b-list-group-item>
              <b-list-group-item class="d-flex justify-content-between align-items-center">
                <h4 class="mb-0">Total Agreements Signed:</h4>
                <span class="badge badge-primary badge-pill">{{ agreements.toFixed() }}</span>
              </b-list-group-item>
              <b-list-group-item class="d-flex justify-content-between align-items-center">
                <h4 class="mb-0">Total Ambassadors:</h4>
                <span class="badge badge-primary badge-pill">{{ ambassadors.toFixed() }}</span>
              </b-list-group-item>
            </b-list-group>
          </b-card>
          <b-card no-body>
            <b-card-header>
              <h3 class="mb-0">Monthly Goals</h3>
            </b-card-header>
            <b-list-group flush>
              <b-list-group-item class="d-flex justify-content-between align-items-center">
                <h4 class="mb-0">Average GCI:</h4>
                <span class="badge badge-primary badge-pill">{{ gci / 12 | currency }}</span>
              </b-list-group-item>
              <b-list-group-item class="d-flex justify-content-between align-items-center">
                <h4 class="mb-0">Closed Volume:</h4>
                <span class="badge badge-primary badge-pill">{{ volume / 12 | currency }}</span>
              </b-list-group-item>
              <b-list-group-item class="d-flex justify-content-between align-items-center">
                <h4 class="mb-0">Closed Units:</h4>
                <span class="badge badge-primary badge-pill">{{ (units / 12).toFixed(2) }}</span>
              </b-list-group-item>
              <b-list-group-item class="d-flex justify-content-between align-items-center">
                <h4 class="mb-0">Total Conversations:</h4>
                <span class="badge badge-primary badge-pill">{{ (conversations / 12).toFixed(2) }}</span>
              </b-list-group-item>
              <b-list-group-item class="d-flex justify-content-between align-items-center">
                <h4 class="mb-0">Total Appointments Held:</h4>
                <span class="badge badge-primary badge-pill">{{ (appointments / 12).toFixed(2) }}</span>
              </b-list-group-item>
              <b-list-group-item class="d-flex justify-content-between align-items-center">
                <h4 class="mb-0">Total Agreements Signed:</h4>
                <span class="badge badge-primary badge-pill">{{ (agreements / 12).toFixed(2) }}</span>
              </b-list-group-item>
              <b-list-group-item class="d-flex justify-content-between align-items-center">
                <h4 class="mb-0">Total Ambassadors:</h4>
                <span class="badge badge-primary badge-pill">{{ (ambassadors / 12).toFixed(2) }}</span>
              </b-list-group-item>
            </b-list-group>
          </b-card>
          <b-card no-body>
            <b-card-header>
              <h3 class="mb-0">Weekly Goals</h3>
            </b-card-header>
            <b-list-group flush>
              <b-list-group-item class="d-flex justify-content-between align-items-center">
                <h4 class="mb-0">Average GCI:</h4>
                <span class="badge badge-primary badge-pill">{{ gci / 46 | currency }}</span>
              </b-list-group-item>
              <b-list-group-item class="d-flex justify-content-between align-items-center">
                <h4 class="mb-0">Closed Volume:</h4>
                <span class="badge badge-primary badge-pill">{{ volume / 46 | currency }}</span>
              </b-list-group-item>
              <b-list-group-item class="d-flex justify-content-between align-items-center">
                <h4 class="mb-0">Closed Units:</h4>
                <span class="badge badge-primary badge-pill">{{ (units / 46).toFixed(2) }}</span>
              </b-list-group-item>
              <b-list-group-item class="d-flex justify-content-between align-items-center">
                <h4 class="mb-0">Total Conversations:</h4>
                <span class="badge badge-primary badge-pill">{{ (conversations / 46).toFixed(2) }}</span>
              </b-list-group-item>
              <b-list-group-item class="d-flex justify-content-between align-items-center">
                <h4 class="mb-0">Total Appointments Held:</h4>
                <span class="badge badge-primary badge-pill">{{ (appointments / 46).toFixed(2) }}</span>
              </b-list-group-item>
              <b-list-group-item class="d-flex justify-content-between align-items-center">
                <h4 class="mb-0">Total Agreements Signed:</h4>
                <span class="badge badge-primary badge-pill">{{ (agreements / 46).toFixed(2) }}</span>
              </b-list-group-item>
              <b-list-group-item class="d-flex justify-content-between align-items-center">
                <h4 class="mb-0">Total Ambassadors:</h4>
                <span class="badge badge-primary badge-pill">{{ (ambassadors / 46).toFixed(2) }}</span>
              </b-list-group-item>
            </b-list-group>
          </b-card>
        </b-card-group>
        <b-row class="justify-content-center" v-else>
          <b-col md="6">
            <b-card>
              <div class="text-center">
                <h2>Add your Annual Goals</h2>
                <b-button class="pulse-btn" variant="danger" v-b-modal.pulse-goals>Annual Goal Calculator</b-button>
              </div>
            </b-card>
          </b-col>
        </b-row>
        <progress-charts :goals="goals" :scores="scores" v-if="goals && scores"></progress-charts>
      </div>
    </b-container>
  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import LoadingPanel from '@/components/LoadingPanel';
import ProgressCharts from './Reports/ProgressCharts';

export default {
  components: {
    LoadingPanel,
    ProgressCharts
  },
  data() {
    return {
      year: new Date().getFullYear(),
      goals: null,
      scores: null,
      loading: true
    }
  },
  computed: {
    ...mapGetters({
      userRoute: 'profile/userRoute'
    }),
    gci() {
      if (this.goals.conversions) {
        return (this.volume / this.units) * (this.goals.avg_commission_percent / 100);
      } else {
        return this.goals.gci;
      }
    },
    commission() {
      if (this.goals.conversions) {
        return (this.goals.closed_volume / this.goals.closed_units) * (this.goals.avg_commission_percent / 100);
      } else {
        return this.goals.avg_sale_price * (this.goals.avg_commission_percent / 100);
      }
    },
    units() {
      if (this.goals.conversions) {
        return this.goals.closed_units;
      } else {
        return this.commission > 0 ? Math.round(this.goals.gci / this.commission) : 0;
      }
    },
    conversations() {
      if (this.goals.conversions) {
        return this.goals.conversations;
      } else {
        return 200 * this.units;
      }
    },
    appointments() {
      if (this.goals.conversions) {
        return this.goals.appt_held;
      } else {
        return 4 * this.units;
      }
    },
    agreements() {
      if (this.goals.conversions) {
        return this.goals.agreements_signed;
      } else {
        return 2 * this.units;
      }
    },
    ambassadors() {
      if (this.goals.conversions) {
        return this.goals.ambassadors;
      } else {
        return 6 * this.units;
      }
    },
    volume() {
      if (this.goals.conversions) {
        return this.goals.closed_volume;
      } else {
        return this.goals.avg_sale_price * this.units;
      }
    }
  },
  methods: {
    getAnnualGoals() {
      axios.get(this.userRoute + "/pulse/pulse-annual-goals?year=" + this.year)
      .then(response => {
        if (response.data.id) {
          this.goals = response.data;
        }
        this.loading = false;
      })
      .catch(error => {
        // 
      });
    },
    getAnnualScores() {
      axios.get(this.userRoute + "/pulse/scores/annual-scores")
      .then(response => {
        this.scores = response.data;
      })
      .catch(error => {
        // 
      });
    }
  },
  mounted() {
    document.title = 'Pulse Dashboard | ClarityNOW';
  },
  created() {
    this.getAnnualGoals();
    this.getAnnualScores();
  }
};
</script>
<style lang="scss">
.bg-pulse-blue {
  background-color: #262262!important;
}
</style>